export function sortIso8601(dateSelector, order = 'desc') {
    return (a, b) => {
        const aDate = dateSelector(a);
        const bDate = dateSelector(b);
        if (order === 'asc')
            return aDate.localeCompare(bDate);
        return -aDate.localeCompare(bDate);
    };
}
